import Modal from 'trunks/vue/admin/components/modals/modal.js';
import AccessModalModel from './access_modal_model.js';

export default Vue.extend({
  components: {
    modal: Modal,
    'access-modal-model': AccessModalModel,
  },

  template: `
    <modal title="编辑角色" extendClass="create-new-access-modal" ref="modal">
      <access-modal-model :options="options"
                          :initialAccess="access"
                          @valueChange="valueChangeFunc"
                          ref="accessModalModelRef"/>
      <div slot='footer' class="modal-footer">
        <button class="outlined btn-default" @click='cancel'>取消</button>
        <button @click='save'>确定</button>
      </div>
    </modal>
  `,

  props: {
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    access: {
      type: Object,
    },
    editSuccessedCallback: {
      type: Function,
    },
  },

  data() {
    return {
      editedAccess: this.access,
    };
  },

  methods: {
    validateAccessName() {
      this.accessNameErrorTip = !this.accessName;
    },

    validateAccessSelect() {
      this.accessSelectErrorTip = !this.selectedItems.length;
    },

    valueChangeFunc(access) {
      this.editedAccess = access;
    },

    save() {
      if (this.$refs.accessModalModelRef.validate()) {
        Skylark.Libs.Ajax.put(`/admin/accesses/${this.access.id}`, {
          contentType: 'application/json; charset=utf-8',
          responseType: 'json',
          data: {
            access: this.editedAccess,
          },
          success: () => {
            Skylark.Bridge.newAlertify('编辑角色成功', {
              type: 'success',
            });
            this.cancel();
            this.editSuccessedCallback(this.editedAccess);
          },
          error(xhr, status, { error }) {
            Skylark.Bridge.newAlertify(error || '编辑角色失败，请重试', {
              type: 'error',
            });
          },
        });
      }
    },

    cancel() {
      this.$refs.modal.close();
    },
  },
});
